module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-col weex-ct weex-div",
    style: ({
      paddingLeft: _vm._px2rem(_vm.padding, 75),
      paddingRight: _vm._px2rem(_vm.padding, 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {}), _vm._v(" "), (_vm.isShowBorderRight && !_vm.isLast) ? _c('div', {
    staticClass: "borderRight weex-ct weex-div",
    style: ({
      top: _vm._px2rem(_vm.borderRightPadding + 'px', 75),
      bottom: _vm._px2rem(_vm.borderRightPadding + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowBorderBottom) ? _c('div', {
    staticClass: "borderBottom weex-ct weex-div",
    style: ({
      left: _vm._px2rem(_vm.isFirst ? _vm.borderBottomPadding + 'px' : '0px', 75),
      right: _vm._px2rem(_vm.isLast ? _vm.borderBottomPadding + 'px' : '0px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowDelta) ? _c('div', {
    staticClass: "delta weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-51c62b44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51c62b44","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-numcard-col/index.vue
// module id = 621
// module chunks = 0 1